import { Icon } from '@mui/material'

import moment from 'moment'

import { Fragment, useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'

import { usePageTracking } from '@services/hooks/useGoogleAnalytics'
import { PAGE_TRACKING_DATA, GA_CONFIG } from '@features/config/analytics'

import { AZURE, REGIONS_STR, useLandingZones } from '@features/hooks/LandingZones'
import { useLogsFirewall } from '@features/hooks/firewall'
// import { getPath } from '@services/utils'

import CollapsibleTable from '@components/CollapsibleTable'
import Tag from '@components/Tag'

import Nodata from '@views/Components/Nodata'
import Filters from '@views/Logs/Components/Filters'
import Detail from '@views/Logs/Firewall/Details'

import { HEADER_HEIGHT } from '@services/theme'
import {useAppSnackbar} from "@services/hooks/AppSnackbar";

export const Firewall = () => {
    const dataStore = useSelector(state => state.firewallLogs)
    const { paginate, reset } = useLogsFirewall()

    const [data, setData] = useState([])
    const [parentSelectorHeight, setParentSelectorHeight] = useState(0)

    const [pagination, setPagination] = useState({page: 0, items: 0})
    const { getProvider } = useLandingZones()

    const { show: showSnackbar } = useAppSnackbar()

    const transformDate = (params) => {
        return moment(params.value).format('DD/MM/YYYY, HH:mm:ss')
    }

    const transformRegion = (params) => {
        return REGIONS_STR[params.value] ?? params.value
    }

    const transformAction = (params) => {
        let label = 'Unknown'
        let color = 'grey'
        let icon = 'help'
        if (params.value === 'Allow') {
            label = 'Allow'
            color = 'green'
            icon = 'check_circle'
        } else if (params.value === 'Deny') {
            label = 'Deny'
            color = 'red'
            icon = 'cancel'
        }

        return (<Tag variant={'main'} chip={{icon: (<Icon color={color}>{icon}</Icon>)}} label={label} color={color} />)
    }

    const headers = useRef([
        {field: 'date', headerName: 'Date', isFirst: true, renderCell: transformDate},
        {field: 'action', headerName: 'Action', renderCell: transformAction},
        {field: 'region', headerName: 'Region', renderCell: transformRegion},
        {field: 'category', headerName: 'Category'},
        {field: 'protocol', headerName: 'Protocol'},
        {field: 'source', headerName: 'Source'},
        {field: 'target', headerName: 'Target'},
        {field: 'reason', headerName: 'Reason'}
    ])

    usePageTracking({
        ...GA_CONFIG.default_data,
        ...PAGE_TRACKING_DATA.lz.logs.firewall
    })

    useEffect(() => {
        reset()

        const parentSelector = document.querySelector('#filters')
        setParentSelectorHeight(parentSelector.clientHeight)

        /* const searchParam = getPath('search', 'hash')
        console.log(searchParam)
        const url = window.location + '?var1=data1&var2=data2';
        window.history.pushState({}, '', url); */
    }, [])

    useEffect(() => {
        setData(dataStore.formated.list)
        setPagination(dataStore.formated.pagination)
    }, [dataStore.formated])

    useEffect(() => {
        if (pagination.itemsCount > 0 && pagination.nextToken)
            showSnackbar('The maximum number of results to display has been reached. Use the filters to refine your search.')
    }, [pagination])

    const handlePageChange = (event, newPage) => {
        if (dataStore.formated.selected
            && getProvider(dataStore.formated.selected) === AZURE)
            paginate(newPage)
    }

    return (
        <Fragment>
            <Filters mode={'firewall'} />

            {(data && data.length > 0) && (
                <CollapsibleTable
                    sx={{border: 0}}
                    headers={headers.current}
                    rows={data}
                    page={pagination.page}
                    itemsCount={pagination.itemsCount}
                    controlledPagination={pagination.controlled}
                    onPageChange={handlePageChange}
                    displayFooter
                    stickyHeader
                    sxGrid={{height: `calc(100dvh - (${parentSelectorHeight}px + ${HEADER_HEIGHT} + 50px))`}}
                >
                    <Detail />
                </CollapsibleTable>
            )}

            {(data && data.length < 1) && (<Nodata sx={{marginTop: '300px !important'}} label={'No data to display'} icon={'search_off'} noIcon img />)}
        </Fragment>
    )
}

export default Firewall